import React from 'react';
import * as _ from 'lodash';
import {getCurrencyValue} from '../../utils/getCurrencyValue';

export function PaymentDataColumnFormatter(cellContent) {
  const description = _.get(cellContent, 'payment.description', '');
  const amount = _.get(cellContent, 'payment.amount', '');
  const currencyCode = _.get(cellContent, 'payment.currency', '');
  const value = [amount, getCurrencyValue(currencyCode)].filter(Boolean).join(' ');

  return (
    <>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {value}
      </div>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {description}
      </div>
    </>
  );
}
